/*
 * 打印管理设置
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-30 19:45:01
 * @Last Modified by: zhiwei.luo@zuolin.com
 * @Last Modified time: 2021-07-15 10:04:07
 */

const api = {
	listPrinters: '/printer/listPrinters', // 查看打印机列表
	updatePrinter: '/printer/updatePrinter', // 修改打印机
	testPrinter: '/printer/testPrinter', // 测试打印机
	deletePrinter: '/printer/deletePrinter', // 删除打印机
	savePrinter: '/printer/savePrinter', // 新增打印机
	findPrinter: '/printer/findPrinter', // 获取单个打印机
	listPrinterVendors: '/printer/listPrinterVendors', // 获取打印机生产厂家
	findPrinterByPrinterSn: '/printer/findPrinterByPrinterSn', //查询打印机是否已被关联，已关联的打印机只能选择一种网络类型
	setStoreReceiptDisplay: '/store/setStoreReceiptDisplay', //
	getStoreReceiptDisplay: '/store/getStoreReceiptDisplay', //
};

const routes = {
	'/print-manage': '打印机管理',
};

export {
	api,
	routes,
};
